import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {AfterViewInit, Component, Inject, ChangeDetectionStrategy} from '@angular/core';
import {Principal} from '../../core/auth/principal.service';
import {GlobalSpinnerService} from '../../core/services/global-spinner.service';
import {SnackBarService} from '../../core/services/snackbar.service';
import {ServerErrorUtils} from '../../shared/utils/server-error-utils';
import {Playlist} from '../../shared/domain/playlist.model';
import {PlaylistsService} from '../../shared/services/playlists.service';
import { RolePermission } from 'src/app/core/auth/rbac/role-permission.service';

@Component({
    selector: 'ctv-playlist-editor-dialog',
    template: `
    <div mat-dialog-title>
      <span>{{readOnly ? 'View Collection' : isEdit ? 'Edit Collection' : 'Create New Collection'}}</span>
    </div>
    <div mat-dialog-content class="collection-dialog-content" [class.dxk-readonly-panel]="readOnly">
      <form #f="ngForm" class="d-flex flex-column">
        <mat-form-field appearance="outline" floatLabel="auto" class="w-100">
          <mat-label>Title</mat-label>
          <input name="title" matInput required [(ngModel)]="playlist.title" placeholder="Enter title"/>
        </mat-form-field>
        <mat-form-field appearance="outline" floatLabel="auto" class="w-100">
          <mat-label>Description</mat-label>
          <input name="description" matInput required [(ngModel)]="playlist.description" placeholder="Enter description"/>
        </mat-form-field>
      </form>
      <div class="row">
        <div class="col-12 mb-3">
          <ctv-categories-multi-select [selectedCategory]="playlist.categories"
                                       [multiple]="true"
                                       floatLabel="auto"
                                       formFieldAppearance="outline"
                                       (categorySelected)="playlist.categories = $event">
          </ctv-categories-multi-select>
        </div>
      </div>
    </div>
    <div mat-dialog-actions>
      <button mat-stroked-button class="" [mat-dialog-close]="false">
        Close
      </button>
      <button mat-flat-button *csHasPermission="RolePermission.COLLECTION_CREATE" class="iconed" color="primary"
              [hidden]="readOnly"
              [disabled]="!f.valid"
              (click)="createPlaylist()">
        <i class="fas fa-save"></i>
        <span>Save</span>
      </button>
    </div>
  `,
    styleUrls: ['./playlist-editor-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PlaylistEditorDialogComponent implements AfterViewInit {
  public readonly RolePermission = RolePermission;

  isEdit: boolean;
  readOnly = false;
  playlist = new Playlist();
  imageFile: File;
  posterFile: File;

  constructor(public dialogRef: MatDialogRef<PlaylistEditorDialogComponent>,
              private service: PlaylistsService,
              private principal: Principal,
              private gss: GlobalSpinnerService,
              private snackBarService: SnackBarService,
              @Inject(MAT_DIALOG_DATA) public data: { playlist?: Playlist; readOnly?: boolean }) {
    this.playlist = new Playlist();
    this.readOnly = !!data?.readOnly;
    if (data && data.playlist) {
      this.isEdit = !!data.playlist;
      this.playlist = data.playlist;
    }
  }

  ngAfterViewInit() {
    this.dialogRef.updateSize('500px');
  }

  createPlaylist() {
    if (this.readOnly) {
      return;
    }
    this.gss.showLoader();
    if (this.isEdit) {
      this.service.update(this.playlist, this.imageFile, this.posterFile).subscribe(next => {
          this.gss.hideLoader();
          this.dialogRef.close(true);
          this.snackBarService.success('Collection updated successfully');
        },
        (e) => {
          const messages = ServerErrorUtils.getValidationMessages(e);
          if (messages) {
            messages.forEach(m => this.snackBarService.error(m));
          } else {
            this.snackBarService.error('Error occurred during collection update');
          }
          this.gss.hideLoader();
        }
      );
    } else {
      this.service.create(this.playlist, this.imageFile, this.posterFile).subscribe(() => {
          this.gss.hideLoader();
          this.dialogRef.close(true);
          this.snackBarService.success('Collection created successfully');
        },
        (e) => {
          const messages = ServerErrorUtils.getValidationMessages(e);
          if (messages) {
            messages.forEach(m => this.snackBarService.error(m));
          } else {
            this.snackBarService.error('Error occurred during collection creation');
          }
          this.gss.hideLoader();
        }
      );
    }
  }
}
